import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { BusinessType, TaxCheckbox } from './components';
;
export const DocumentTwelve = memo(({ pharmacy, traderInfo, }) => {
    const styles = StyleSheet.create({
        container: {
            padding: 35,
        },
        entryContainer: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 3,
            padding: 7,
        },
        customerNumber: {
            paddingBottom: 12,
            fontSize: 10,
        },
        entry: {
            paddingLeft: 0,
            paddingBottom: 7,
            fontSize: 10,
        },
        entrySm: {
            paddingLeft: 0,
            paddingBottom: 3,
            fontSize: 10,
        },
        entryMd: {
            padding: '5px 0px 13px 0px',
            fontSize: 9.5,
            textDecoration: 'underline',
        },
        entryLg: {
            paddingLeft: 0,
            paddingBottom: 6,
            fontSize: 13,
            textDecoration: 'underline',
        },
        titleContainer: {
            flexDirection: 'column',
            marginBottom: 0,
            padding: 3,
            justifyContent: 'center',
            textAlign: 'center',
            alignContent: 'center',
        },
        title: {
            paddingTop: 0,
            paddingBottom: 5,
            fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: 15,
            paddingLeft: 3,
        },
        questionFourContainer: {
            paddingBottom: 10,
        },
    });
    const TaxCheckboxes = useMemo(() => {
        const { state, } = pharmacy;
        return (_jsxs(_Fragment, { children: [_jsxs(View, { style: styles.entryContainer, children: [_jsx(TaxCheckbox, { checkmark: '', text: 'Check if you are attaching the Multistate supplemental form' }), _jsx(TaxCheckbox, { checkmark: state[0], checkmark2: state[1], text: 'If not, enter the two-letter postal abbreviation for the state under whose laws you are claiming exemption.' })] }), _jsx(View, { style: styles.entryContainer, children: _jsx(TaxCheckbox, { checkmark: '', text: 'Check if this certificate is for a single purchase and enter the related invoice/purchase order # _____________' }) })] }));
    }, [pharmacy]);
    const questionThreeItems = [
        `Name of Purchaser:  ${pharmacy.legalName}`,
        `Purchaser's Business Address:  ${pharmacy.address}, ${pharmacy.city}, ${pharmacy.state} ${pharmacy.zipCode}`,
        `Purchaser's Tax ID #:  ${pharmacy.federalTaxNumber}     State of Issue:  ${pharmacy.stateOfIncorporation}     Country of Issue:  USA`,
        '',
        'Name of Seller:  Prescription Supply, Inc.',
        'Seller\'s Address:  2233 Tracy Road     City:  Northwood     State:  OH     Zip Code:  43619',
    ];
    const questionFourItems = useMemo(() => [
        { leftText: '01 Accommodation and food services', rightText: '11 Transportation and warehousing', },
        { leftText: '02 Agricultural, forestry, fishing, hunting', rightText: '12 Utilities', },
        { leftText: '03 Construction', rightText: '13 Wholesale trade', },
        { leftText: '04 Finance and insurance', rightText: '14 Business services', },
        { leftText: '05 Information, publishing and communications', rightText: '15 Professional services', },
        { circleText: '16', leftText: '06 Manufacturing', rightText: 'Education and health-care services', },
        { leftText: '07 Mining', rightText: '17 Nonprofit organization', },
        { leftText: '08 Real estate', rightText: '18 Government', },
        { leftText: '09 Rental and leasing', rightText: '19 Not a business', },
        { leftText: '10 Retail trade', rightText: '20 Other (explain)_______________', },
    ], []);
    const questionFiveItems = useMemo(() => [
        { leftText: 'A Federal government (department)', rightText: 'H Agricultural production #', },
        { leftText: 'B State or local government (name)', rightText: 'I Industrial production/manufacturing #', },
        { leftText: 'C Tribal government (name)', rightText: 'J Direct pay permit #', },
        { leftText: 'D Foreign diplomat #', rightText: 'K Multiple points of use (services, digital goods, or computer software delivered electronically)', },
        { leftText: 'E Charitable organization #', rightText: 'L Direct mail #', },
        { circleText: 'M', leftText: 'F Religious or educational organization #', rightText: 'Other (explain)___Prescription Supply____', },
        { leftText: 'G Resale #', rightText: '', },
    ], []);
    const SignHere = useMemo(() => {
        const date = dayjs().format('MM/DD/YYYY');
        const { owner, } = traderInfo;
        return (_jsxs(View, { style: styles.entryContainer, children: [_jsx(Text, { style: styles.entryMd, children: "Sign Here. I declare that the information on this certificate is correct and complete to the best of my knowledge and belief" }), _jsx(Text, { style: styles.entrySm, children: `Signature:                                        Print:  ${owner.firstName} ${owner.lastName}     Title:  Owner     Date:  ${date}` })] }));
    }, []);
    return (_jsx(Page, { size: 'A4', wrap: false, children: _jsxs(View, { style: styles.container, children: [_jsxs(View, { style: styles.titleContainer, children: [_jsx(Text, { style: styles.customerNumber, children: "Customer #: ____________" }), _jsx(Text, { style: styles.title, children: "Streamlined Sales and Use Tax Agreement Certificate of Exemption" })] }), _jsxs(View, { style: styles.entryContainer, children: [_jsx(Text, { style: styles.entrySm, children: "This is a multistate form. Not all states allow all exemptions listed on this form. Purchasers are responsible for knowing if they qualify to claim exemption from tax in the state that would otherwise be due tax on this sale. The seller may be required to provide this exemption certificate (or the data elements required on the form) to a state that would otherwise be due tax on this sale" }), _jsx(Text, { style: styles.entrySm, children: "The purchaser will be held liable for any tax and interest, and possibly civil and criminal penalties imposed by the member state, if the purchaser is not eligible to claim this exemption. A seller may not accept a certificate of exemption for an entity-based exemption on a sale made at a location operated by the seller within the designated state if the state does not allow such an entity-based exemption." })] }), TaxCheckboxes, _jsx(View, { style: styles.entryContainer, children: questionThreeItems.map((text, index) => _jsx(Text, { style: styles.entry, children: text }, index)) }), _jsxs(View, { style: styles.questionFourContainer, children: [_jsx(Text, { style: styles.entryLg, children: "Type of business. Circle the number that describes your business" }), questionFourItems.map((props, index) => _jsx(BusinessType, { ...props }, index))] }), _jsxs(View, { children: [_jsx(Text, { style: styles.entryLg, children: "Reason for exemption. Circle the letter that identifies the reason for exemption" }), questionFiveItems.map((props, index) => _jsx(BusinessType, { ...props }, index))] }), SignHere] }) }));
});
